<template>
  <div class="contact bg-1 text-light flex-column">
    <div class="content">
      <div class="title-3">Fale Conosco</div>
      <div class="body-2">Digite as suas informações e selecione o setor que deseja enviar a sua mensagem.</div>
      <form ref="form" @submit.prevent="sendEmail" class="form flex align-left">
        <div class="img">
          <div>
            <img :src="require(`@/assets/topazinho/topazinho-2.png`)">
          </div>
        </div>
        <div class="fields flex-column">
          <input type="text" autocomplete="off" :disabled="sending" v-model="nome" name="nome" placeholder="Seu nome">
          <input type="email" autocomplete="off" :disabled="sending" v-model="email" name="email" placeholder="Email">
          <input type="text" autocomplete="off" :disabled="sending" v-model="assunto" name="assunto" placeholder="Assunto">
          <select v-model="setor" name="setor" id="setor">
            <option value="comercial" label="Comercial">Comercial</option>
            <option value="financeiro" label="Financeiro">Financeiro</option>
            <option value="reclamacoes" label="Reclamações">Reclamações</option>
            <option value="desenvolvimento" label="Outros">Outros</option>
          </select>
          <textarea name="message" autocomplete="off" :disabled="sending" v-model="message" placeholder="Mensagem"></textarea>
          <button type="submit" :disabled="!form" class="btn btn-primary">Enviar</button>
        </div>
        <div class="sending flex-column align-center">
          <div class="svg">
            <svg class="loading" width="84" height="82" viewBox="0 0 48 46" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 43.5019V15.0406C19 15.0406 19.0977 14.5413 10.6988 17.0379C2.29988 19.5345 1.5358 24.0692 4.77232 31.0189C8.00884 37.9686 8.10381 44.9999 11.7364 44.9999C15.3691 44.9999 19 43.5019 19 43.5019Z" stroke="#00A859" />
              <path d="M28 41.4999V15.4999C32.3073 15.5217 33 15.4996 37 16.9998C41 18.4999 52 32.9999 44.5 35.9999C37 38.9999 33.7179 39.7305 28 41.4999Z" stroke="#D2D3D5" />
              <path d="M41 10H1C1 10 33 1.00014 36.5 1C40 0.999862 41 10 41 10Z" stroke="#ED3237" />
            </svg>
            <div class="subtitle-5 text-white">Enviando</div>
          </div>
        </div>
      </form>
      <hr>
      <div class="linkedin">
        <span class="title-1">Acompanhe nosso Linkedin</span>
        <div class="body-2">
          E fique de olho em nossas oportunidades de carreira
        </div>
        <a href="https://www.linkedin.com/company/grupotop%C3%A1zio/jobs/" target="_blank">
          <div class="linkedin-img gradient">
            <div>
              <img src="@/assets/banner-linkedin.png">
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import emailjs from 'emailjs-com'

export default {
  name: 'ContatcUs',
  data () {
    return {
      nome: '',
      email: '',
      assunto: '',
      setor: '',
      message: '',
      sending: false
    }
  },
  computed: {
    form () {
      return Boolean(this.nome && this.email && this.assunto && this.setor && this.message)
    }
  },
  methods: {
    async sendEmail () {
      this.sending = true
      document.querySelector('.form .sending').style.display = 'flex'
      await emailjs.sendForm('service_6eaca5q', 'template_4bttnjj', this.$refs.form, 'user_TXRTNr2XktCGsRf8jRvkk')
        .then(() => {
          console.log('enviado')
          this.nome = ''
          this.email = ''
          this.assunto = ''
          this.setor = ''
          this.message = ''
          document.querySelector('.form .sending').style.display = 'none'
          this.sending = false
        }, (error) => {
          console.log(error)
          document.querySelector('.form .sending').style.display = 'none'
          this.sending = true
        })
    }
  }
}
</script>

<style lang="scss">
// reset backgrounds
.contact-us {
  display: block !important;
}
.contact-us body {
  background-color: #005245 !important;
  z-index: -1;
}
.contact-us #header {
  background: transparent;
}
.contact-us #content {
  margin: 0 0 !important;
}
.contact-us #footer {
  margin: 0 0 !important;
  background: #005245;
  .footer .background {
    bottom: -80px;
    transform: rotate(0);
  }
}
.contact {
  justify-content: start;
  position: relative;
}
  .contact:after {
  content: '';
  opacity: .4;
  position: absolute;
  height: 100%;
  width: 100%;
  background: url("../assets/capas/fale-conosco.webp") no-repeat center;
  background-size: cover;
  backdrop-filter: opacity(40%) !important;
}
.contact .content {
  z-index: 1;
  margin: 140px auto 0 auto;
  padding: 0 70px;
  text-align: start;
  .body-2 {
    margin: 15px 0;
    max-width: 370px;
  }
  .form {
    position: relative;
    margin-top: 40px;
    .img {
      width: 315px;
      height: 308px;
      margin-right: 40px;
      div {
        width: 100%;
        height: 100%;
        img {
          min-width: 315px;
          width: 120%;
          margin-left: -5%;
        }
      }
    }
    select {
      background: none;
      border: none;
      margin-left: 6px;
      opacity: .7;
      min-width: 211px;
      max-width: 232px;
      border-bottom: solid 1px #C3C3C3;
      outline: none;
      color: #C3C3C3;
      font-weight: 500;
      transition: all .4s ease;
      margin-bottom: 20px;
      option {
        background-color: #E8E8E8;
        color: #3e3e3e;
        font-weight: 500;
        font-size: 14px;
      }
    }
    select:focus {
      opacity: 1;
    }
    input {
      border-bottom: solid 1px #C3C3C3;
      color: #C3C3C3;
      opacity: .7;
      min-width: 211px;
      width: 30vw;
    }
    input:focus {
      opacity: 1;
    }
    input::placeholder {
      color: #C3C3C3;
      opacity: .5;
    }
    textarea {
      min-width: 265px;
      width: 49vw;
      max-width: 562px;
      height: 124px;
      background: none;
      color: #C3C3C3;
      outline: none;
      padding: 6px;
      font-weight: 600;
      border-radius: 7px;
      border-color: #C3C3C3;
      opacity: .6;
      transition: all .3s ease;
    }
    textarea:focus {
      opacity: 1;
    }
    textarea::placeholder {
      color: #C3C3C3;
      opacity: .7;
    }
    .btn {
      margin: 30px auto 0 auto;
    }
  }
  .form .sending {
    display: none;
    content: '';
    position: absolute;
    border-radius: 20px;
    width: 100%;
    height: 100%;
    background: rgba(0, 82, 69, 0.75);
    color: #C3C3C3 !important;
    .svg {
      margin: auto;
    }
  }
  .form.before {
    content: 'Enviando...';
    font-weight: bold;
    z-index: 1;
    position: absolute;
    margin: 170px 0 0 33vw;
  }
  .linkedin {
    text-align: center;
    .title-1:after {
      background: #B01212;
      height: 7px;
    }
    .body-2 {
      margin: 10px auto;
      min-width: 500px;
    }
    .linkedin-img {
      margin: 20px auto;
      width: 87vw;
      height: 40vw;
      max-width: 1000px;
      max-height: 460px;
      z-index: 1;
      div {
        width: 100%;
        height: 100%;
        min-height: 130px;
        background: url("../assets/logos/logo-icon.png") no-repeat center;
        background-size: 75px;
        img {
          height: 105%;
          margin-left: -90px;
          transition: all .3s ease;
        }
      }
    }
    a:hover > .linkedin-img img {
      height: 108%;
      margin-left: -105px;
      filter: brightness(1.1);
    }
  }
  @media screen and (max-width: 917px){
    .form {
      .img {
        display: none;
      }
    }
    .title-1 {
      font-size: 30px !important;
      line-height: 35px !important;
    }
    .title-1:after {
      display: none;
    }
    .linkedin .body-2 {
      margin: 10px auto;
      min-width: 280px !important;
    }
    .linkedin-img img {
      height: 105%;
      margin-left: -8vw !important;
    }
  }
}
@media screen and (max-width: 525px){
  .contact .content {
    padding: 0 20px;
  }
}
</style>